'use client';

import { AppLanguageCode } from '@repo/entities/AppLanguage';
import { createContext } from 'react';

export type LanguageContextValue = {
  languageCode: AppLanguageCode;
  setLanguageCode: (languageCode: AppLanguageCode) => void;
};

// Outside a provider it is fixed English, so hook tests need no wrapper.
export const languageContext = createContext<LanguageContextValue>({
  languageCode: 'en',
  setLanguageCode: () => {},
});
